import React from "react";

const RelationSelect = ({ name, label, options, error, ...rest }) => {
	return (
		<div className='form-group'>
			<label htmlFor={name}>{label}</label>
			<select name={name} id={name} {...rest} className='form-control'>
				<option value='' />
				{options.map((option) => (
					<option key={option.relation_id} value={option.relation_id}>
						{option.relation_name}
					</option>
				))}
			</select>

			{error && <div className='alert alert-danger'>{error}</div>}
		</div>
	);
};

export default RelationSelect;
